<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="page-login" class="login-main">
    <div class="login-container">

      <div class="login-top">
        <img src="../../../public/img/TurkishRestaurantLogo.png" />
      </div>
      <div class="login-mid fp">
        <h3>Forgot Password</h3>
        <p>Choose your role </p>
        <select class="login-role-select fp" v-model="user_group">
                    <option v-for="(item, index) in user_group_options" :key="index" :value="item.value">{{item.label}}</option>
                  </select>
                  <p>Enter your email</p>
        <input
                    name="email"
                    placeholder="Email"
                    v-model="email"
                    @keyup.enter="login"
                    class="login-input fp"/>
    </div>
    <div class="login-bottom">
      <button class="login-button" @click="login">Send Reset Link</button>
      <a href="/login" class="login-back-button"><i class="fas fa-angle-left"></i> Go back</a>
    </div>
    </div>
  </div>
</template>

<script>
import Logo from '../../layouts/components/Logo.vue'

export default{
  components: {
    Logo
  },
  data () {
    return {
      email: '',
      user_group: 2,
      user_group_options: [{label: 'Restaurant Owner', value: 2}, {label: 'Editor', value: 3}, {label: 'Admin', value: 4}]
    }
  },
  methods: {
    login () {
      if (this.email !== '') {
        this.$vs.loading()
        const passmail = {
          email: this.email, //'serkan.erdinc@asay.com.tr',
          redirectUrl: 'https://restadmin.turkishrestaurant.com/reset-password/{token}', //'ser123',
          user_group: this.user_group
        }
        this.$store.dispatch('api/forgotPassword', passmail)
          .then(() => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Email sent successfully',
              text: 'please check your inbox',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
          })
          .catch(error => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Error',
              text: error.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })
      } else {

        this.$vs.notify({
          title: 'Error',
          text: 'Email field can not be empty',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
  .login-header {
    text-align: center;
    padding: 1rem;
    justify-content: center;
  }
  .vx-card {
    overflow:hidden;
  }
  .vx-logo-text {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
